export type TPartnerFlag = {
  EntryID: number
  AgreementNo: string | null
  ApolloCode: string | null
  Code: string
  CodeName: string
  CodeType: CodeType
  Currency: string | null
  END_DATE: string
  GeoRegion: string
  PARTNER_ID: string
  Revision: number | null
  SIGNATURE_DATE: string | null
  START_DATE: string
  TopPartnerID: string
}

export enum CodeType {
  Accreditation = 'Accreditation',
  Agreement = 'Agreement',
  Program = 'Program',
}
